import React, { ReactNode } from 'react'
import Drawer from '@mui/material/Drawer';
type props={
    children: ReactNode,
    open: boolean,
    anchor?: "left" | "right" | "top" | "bottom"
}
export default function AppDrawer({open,children,anchor="right"}:props) {

  return (
      <Drawer 
       anchor={anchor}
       open={open}
      > 
        {children}
      </Drawer>
  ) 
}
